(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = (root = document) => root.querySelectorAll('.nc-reveal').forEach((el) => el.classList.add('nc-visible'));
  if (reduce || !('IntersectionObserver' in window)) {
    reveal();
    return;
  }
  document.documentElement.classList.add('nc-motion-ready');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('nc-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.16 });
  document.querySelectorAll('.nc-reveal').forEach((el) => observer.observe(el));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.nc-reveal').forEach((el) => observer.observe(el));
  });
})();
